import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { CSVLink } from "react-csv";
import moment from "moment";
import {
  GetEmployeeReferralList,
  DeleteReferralData,
} from "../../services/EmployeeReferralService";
import { toast } from "react-toastify";
import { Container, Row, Col } from "react-bootstrap";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import {
  checkPermissionStatus,
  generateMaskedPII,
  getCompanyTimezoneDateTime,
} from "helpers/utils";

import delete_icon from "../../assets/images/icon/delete.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const EmployeeReferralList = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [employeeReferralList, setEmployeeReferralList] = useState([]);
  const [query, setQuery] = useState("");
  const [csvData, setCSVData] = useState([]);
  const [error, setError] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const companyId = localStorage.getItem("subdomainId");

  useEffect(() => {
    GetEmployeeReferralList()
      .then(res => {
        if (res?.status === 200) {
          setEmployeeReferralList(res?.data?.data);
        }
      })
      .catch(err => {
        toast.error(t(`EmployeeReferral.No data Available`));
      });
    document.title = "NeuroTal - Employee Referral List";
  }, []);

  const handleDeleteRecords = id => {
    DeleteReferralData(id)
      .then(res => {
        if (res?.status === 200) {
          let messages = toast.success(res?.data?.message);
          setTimeout(() => {
            history.push("/employee-referral-list");
          }, 1000);
          // Adjust the delay time as needed (3000 milliseconds = 3 seconds)
        } else {
          let messages = toast.error(res?.data?.message);
        }
      })
      .catch(error => {
        console.error("Error deleting record:", error);
      });
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`EmployeeReferral.Showing rows`, { from, to, size })}
    </span>
  );

  //Handle CSV

  const handleCSVDownload = async e => {
    e.preventDefault();
    let data = employeeReferralList?.filter(renderCheck)?.map(item => ({
      ...item,
      candidate_email: generateMaskedPII(item?.candidate_email),
      candidate_mobile: generateMaskedPII(item?.candidate_mobile, 2),
    }));
    setCSVData(data);
    setTimeout(() => {
      let element = document.getElementById("downloadCSV");
      element.click();
    }, 1000);
  };

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  let columns = [
    {
      text: t(`EmployeeReferral.id`),
      dataField: "_id",
      sort: true,
      hidden: true,
    },
    {
      dataField: "Company.company_name",
      text: t(`EmployeeReferral.Company Name`),
      hidden: companyId, // Hide the column if companyId exist
    },
    {
      dataField: "vacancyType",
      text: t(`EmployeeReferral.Vacancy Type`),
    },
    {
      dataField: "department",
      text: t(`EmployeeReferral.Department`),
    },
    {
      dataField: "vacancy.title",
      text: t(`EmployeeReferral.Job Title`),
    },
    {
      dataField: "ref_emp_id",
      text: t(`EmployeeReferral.Referral Emp ID`),
    },
    {
      dataField: "ref_emp_name",
      text: t(`EmployeeReferral.Referral Emp Name`),
    },
    {
      dataField: "ref_emp_email",
      text: t(`EmployeeReferral.Referral Emp Email`),
      formatter: (cell, row) => <>{generateMaskedPII(row?.ref_emp_email)}</>,
    },
    {
      dataField: "candidate_name",
      text: t(`EmployeeReferral.Candidate Name`),
    },
    {
      dataField: "candidate_email",
      text: t(`EmployeeReferral.Candidate Email`),
      formatter: (cell, row) => <>{generateMaskedPII(row?.candidate_email)}</>,
    },
    {
      dataField: "candidate_mobile",
      text: t(`EmployeeReferral.Candidate Mobile`),
      formatter: (cell, row) => (
        <>{generateMaskedPII(row?.candidate_mobile, 2)}</>
      ),
    },
    {
      dataField: "master_city.city",
      text: t(`EmployeeReferral.City`),
    },
    {
      dataField: "master_area.area_name",
      text: t(`EmployeeReferral.Preferred Location`),
    },
    {
      dataField: "createdAt",
      text: t(`EmployeeReferral.Created At`),
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },
    {
      dataField: "status",
      text: t(`EmployeeReferral.Status`),
      formatter: (cellContent, row) => (
        <>
          {row?.status == "1"
            ? t(`EmployeeReferral.Active`)
            : t(`EmployeeReferral.In Active`)}
        </>
      ),
    },
  ];

  if (checkPermissionStatus("employee-referral-list", "edit")) {
    columns.push({
      dataField: "",
      text: t(`EmployeeReferral.Actions`),
      formatter: (cell, row) => {
        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/employee-referral-edit/${row.id}`}
                title="Edit Employee Referral"
              >
                <img src={edit_icon} alt="edit_icon" />
                <span>{t(`EmployeeReferral.Edit`)}</span>
              </Link>
            </div>

            <div className="action-one small-img">
              <div
                onClick={() => handleDeleteRecords(row.id)}
                className="text-success blue-icon blue-color3"
                style={{ cursor: "pointer" }}
                to="#"
                title="Delete Record"
              >
                <img src={delete_icon} alt="delete_icon" />
                <span>{t(`EmployeeReferral.Delete`)}</span>
              </div>
            </div>
          </div>
        );
      },
    });
  }

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const renderCheck = item => {
    const searchableText = (
      item?.vacancy_id +
      item?.candidate_name +
      item?.candidate_email +
      item?.candidate_mobile +
      item?.ref_emp_name +
      item?.ref_emp_id +
      item?.ref_emp_mobile +
      item?.ref_emp_email +
      moment(getCompanyTimezoneDateTime(item?.createdAt)).format(
        "DD MMM YYYY"
      ) +
      (item?.status === "1"
        ? t(`EmployeeReferral.Active`)
        : t(`EmployeeReferral.Inactive`))
    ).toLowerCase();
    return searchableText.includes(query.toLowerCase());
  };

  

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  if (!checkPermissionStatus("employee-referral-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`EmployeeReferral.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="pending-list-page feedbacks departmentpage">
        <div className="tab-content" id="pills-tabContent">
          <div className="joblist-container create-vacancy main-pages-s">
            <Row className="mb-2 align-items-center">
              <Col lg="6" md="6" className="Joblist-column">
                <Link to="/dashboard">
                  <h5 className="text-uppercase heading-one">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`EmployeeReferral.Employee Referral List`)}
                  </h5>
                </Link>
              </Col>
            </Row>
          </div>

          {/* <div className="outerTab-box-wrapper below-vacancy  positon-app  applicationcard-table"> */}
          <div className="outerTab-box-wrapper applicationcard-table">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive pb-3">
                <div className="table-data-search">
                  <div className="total-record">
                    <h5>
                      {t(`EmployeeReferral.Total Records`)}{" "}
                      <span>{employeeReferralList?.length || 0}</span>
                    </h5>
                  </div>
                  <div className="total-serachbar">
                    <div className="serach-bar-top">
                      <form class="form-inline">
                        <input
                          className="form-control mr-sm-2"
                          type="search"
                          placeholder={
                            t(`EmployeeReferral.Search by Candidate`).slice(
                              0,
                              30
                            ) + "....."
                          }
                          aria-label="Search"
                          onChange={e => setQuery(e.target.value)}
                          title={t("EmployeeReferral.Search by Candidate")}
                        />
                        <span>
                          <img src={serach_icon} alt="search" />
                        </span>
                      </form>
                    </div>
                    {checkPermissionStatus(
                      "employee-referral-list",
                      "downloadcsv"
                    ) && (
                      <div className="take-text">
                        <CSVLink
                          data={csvData}
                          headers={[
                            {
                              key: "id",
                              label: t(`EmployeeReferral.S No`),
                            },
                            {
                              key: "VacancyType.title",
                              label: t(`EmployeeReferral.Vacancy Type`),
                            },
                            {
                              key: "department.name",
                              label: t(`EmployeeReferral.Department`),
                            },
                            {
                              key: "ref_emp_id",
                              label: t(`EmployeeReferral.Referral Emp ID`),
                            },
                            {
                              key: "ref_emp_name",
                              label: t(`EmployeeReferral.Referral Emp Name`),
                            },
                            {
                              key: "candidate_name",
                              label: t(`EmployeeReferral.Candidate Name`),
                            },
                            {
                              key: "candidate_email",
                              label: t(`EmployeeReferral.Candidate Email`),
                            },
                            {
                              key: "candidate_mobile",
                              label: t(`EmployeeReferral.Candidate Mobile`),
                            },
                            {
                              key: "master_city.city",
                              label: t(`EmployeeReferral.City`),
                            },
                            {
                              key: "master_city.city",
                              label: t(`EmployeeReferral.Preferred Location`),
                            },
                            {
                              key: "status",
                              label: t(`EmployeeReferral.Status`),
                            },
                            {
                              key: "createdAt",
                              label: t(`EmployeeReferral.Created Date`),
                            },
                            {
                              key: !companyId ? "Company.company_name" : "", // Conditionally include "Company Name" if companyId does't exists
                              label: !companyId
                                ? t(`EmployeeReferral.Company Name`)
                                : "",
                            },
                          ]}
                          filename={`EmployeeReferralList.csv`}
                          id="downloadCSV"
                        >
                          <Button
                            color="info"
                            onClick={e => handleCSVDownload(e)}
                            outline
                          >
                            <img src={dowanload_csv} alt="Download" />{" "}
                            {t(`EmployeeReferral.Download CSV`)}
                          </Button>
                        </CSVLink>
                      </div>
                    )}
                    {checkPermissionStatus(
                      "employee-referral-list",
                      "create"
                    ) && (
                      <div className="take-text filter">
                        <Link
                          to="/create-employee-referral"
                          className="btn btn-primary"
                        >
                          + {t(`EmployeeReferral.Create`)}
                        </Link>
                      </div>
                    )}

                    <div className="tale-text right-panel">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip={t(`EmployeeReferral.Scroll Left`)}
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip={t(`EmployeeReferral.Scroll Right`)}
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                    </div>
                  </div>
                </div>
                {successMessage && (
                  <div class="alert alert-success" role="alert">
                    {successMessage}
                  </div>
                )}
                {errorMessage && (
                  <div class="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                )}

                {/* <div className="timeto-hire-card userlist"> */}
                <div className="timeto-hire-card userlist pendiglist-cardss">
                  <div className="table-custome-class range-custome">
                    <>
                      <div className="scroll-container">
                        <div className="table-pending-list">
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <BootstrapTable
                              keyField="id"
                              data={employeeReferralList?.filter(renderCheck)}
                              columns={columns}
                              pagination={paginationFactory(options)}
                              rowClasses={rowClasses}
                              hover
                              responsive
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeReferralList;
